var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import infraService from "@/core/services/infraService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Informativo_MicroServicosActions } from "@/store/enums/InfraEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Informativo_MicroServicosModule = class Informativo_MicroServicosModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Informativo_MicroServicosActions.POST_INFORMATIVO_MICROSERVICOS](data) {
        return new Promise(resolve => {
            infraService.post("Informativo_MicroServicos/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Informativo_MicroServicosActions.POST_RANGE_INFORMATIVO_MICROSERVICOS](data) {
        return new Promise(resolve => {
            infraService.post("Informativo_MicroServicos/PostRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Informativo_MicroServicosActions.PUT_INFORMATIVO_MICROSERVICOS](data) {
        return new Promise(resolve => {
            infraService.put("Informativo_MicroServicos/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Informativo_MicroServicosActions.DELETE_INFORMATIVO_MICROSERVICOS](data) {
        return new Promise(resolve => {
            infraService.delete("Informativo_MicroServicos/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Informativo_MicroServicosActions.DELETE_RANGE_INFORMATIVO_MICROSERVICOS](data) {
        return new Promise(resolve => {
            infraService.post("Informativo_MicroServicos/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Informativo_MicroServicosActions.FILTER_INFORMATIVO_MICROSERVICOS](data) {
        return new Promise(resolve => {
            infraService.post("Informativo_MicroServicos/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Informativo_MicroServicosActions.GET_INFORMATIVO_MICROSERVICOS]() {
        return new Promise(resolve => {
            infraService.get("Informativo_MicroServicos/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Informativo_MicroServicosActions.GET_BY_ID_INFORMATIVO_MICROSERVICOS](data) {
        return new Promise(resolve => {
            infraService.get("Informativo_MicroServicos/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Informativo_MicroServicosActions.GET_BY_STRING_INFORMATIVO_MICROSERVICOS](data) {
        return new Promise(resolve => {
            infraService.get("Informativo_MicroServicos/GetByString", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Informativo_MicroServicosActions.GET_PAGED_BY_STRING_INFORMATIVO_MICROSERVICOS](data) {
        return new Promise(resolve => {
            infraService.get("Informativo_MicroServicos/GetPagedByString", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_MicroServicosModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_MicroServicosModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_MicroServicosModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_MicroServicosModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_MicroServicosModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_MicroServicosModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Informativo_MicroServicosModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_MicroServicosModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_MicroServicosModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Informativo_MicroServicosModule.prototype, _k, null);
Informativo_MicroServicosModule = __decorate([
    Module
], Informativo_MicroServicosModule);
export default Informativo_MicroServicosModule;
//# sourceMappingURL=Informativo_MicroServicosModule.js.map